import React from "react";
import Chip from "@mui/material/Chip";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Tooltip from "@mui/material/Tooltip";
import { useGame } from "@seabrookstudios/pitch2table";

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {number} props.filteredIndex
 */
export const LiveVersionChip = ({ gameId, filteredIndex }) => {
  const { data: game } = useGame(gameId);
  const isMostRecentVersion = filteredIndex === 0;
  const isPublicGame = game?.visibility === "Public";

  if (!isMostRecentVersion || !isPublicGame) {
    return null;
  }

  return (
    <ListItemSecondaryAction>
      <Tooltip title="This version is currently visible on the public page for this game.">
        <Chip label="LIVE" color="success" />
      </Tooltip>
    </ListItemSecondaryAction>
  );
};
